/**个税申报 */
import { $http, buildHeaders } from "./index";

//获取列表
export const taxdeclare_list = (params) => {
  return $http.get("/admin/TaxDeclare/index", { params });
};

//获取统计
export const taxdeclare_getstatistics = (params) => {
  return $http.get("/admin/TaxDeclare/getStatistics", { params });
};

//导出
export const taxdeclare_export = (params) => {
  return $http.get("/admin/TaxDeclare/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//获取所得类型汇总列表
export const taxdeclare_list_children = (params) => {
  return $http.get("/admin/TaxDeclare/getTaxDeclareTypeStat", {
    params: { limit: 0, ...params },
  });
};

//获取所得类型员工列表
export const taxdeclare_getemployee = (params) => {
  return $http.get("/admin/TaxDeclare/getTaxDeclareEmployee", { params });
};

//更新申报结果
export const taxdeclare_update = (data) => {
  return $http.post(
    "/admin/TaxDeclare/getDeclareResult",
    { id: data },
    {
      headers: buildHeaders(3),
    }
  );
};

//批量申报
export const taxdeclare_doDeclares = (data) => {
  return $http.post(
    "/admin/TaxDeclare/doDeclares",
    { id: data },
    {
      headers: buildHeaders(3),
    }
  );
};

//作废申报
export const taxdeclare_cancel = (id) => {
  return $http.post(
    "/admin/TaxDeclare/cancel",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//批量锁定
export const taxdeclare_lock = (data) => {
  return $http.post(
    "/admin/TaxDeclare/lock",
    { id: data },
    {
      headers: buildHeaders(3),
    }
  );
};

//批量解锁
export const taxdeclare_unlock = (data) => {
  return $http.post(
    "/admin/TaxDeclare/unlock",
    { id: data },
    {
      headers: buildHeaders(3),
    }
  );
};

//获取填写附表数据
export const taxdeclare_getattachedinfo = (id) => {
  return $http.get("/admin/TaxDeclare/getAttachedInfo", { params: { id } });
};

//获取填写附表列表
export const taxdeclare_getattachedlist = (params) => {
  return $http.get("/admin/TaxDeclare/getAttachedList", { params });
};

//编辑
export const taxdeclare_editattached = (data) => {
  return $http.post("/admin/TaxDeclare/editAttached", data, {
    headers: buildHeaders(3),
  });
};


//批量编辑
export const taxdeclare_editattachedbatch = (data) => {
  return $http.post("/admin/TaxDeclare/editAttachedBatch", data, {
    headers: buildHeaders(3),
  });
};

//全渠道申报状态查询
export const taxdeclare_querydeclarationrecord = (data) => {
  return $http.post("/admin/TaxDeclare/queryDeclarationRecord", data, {
    headers: buildHeaders(3),
  });
};
